module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-500.8b7179f8.ttf";